export default __webpack_public_path__ + "static/media/ic_menu_dots.ba19dad8.svg";